import { makeThemedStyles } from "qpr-base/viewcomponents/utils";

const useFileFormatButtonStyles = makeThemedStyles(
  "Toolbar.ExportDashboardFileFormats",
  (theme) => ({
    button: {
      padding: "12px 20px",
      borderRadius: "5px",
    },
    container: {
      display: "flex",
      justifyContent: "space-evenly",
      alignSelf: "stretch",
      marginTop: "0.5em",
      margin: "10px",
      gap: "10px",
    },
    pdf: {
      backgroundColor: "rgba(0, 169, 163, 0.1)",
      "&:hover": {
        background: "rgba(0, 169, 163, 0.1)",
      },
    },
    pptx: {
      backgroundColor: "rgba(246, 117, 26, 0.1)",
      "&:hover": {
        background: "rgba(246, 117, 26, 0.1)",
      },
    },
    xlxs: {
      backgroundColor: "rgba(23, 246, 26, 0.1)",
      "&:hover": {
        background: "rgba(28, 240, 26, 0.1)",
      },
    },
  })
);
export default useFileFormatButtonStyles;
